// ────────────────────────────────────────────────────────────────────────────
// Web doesn't have a native payment button.
export const StripePaymentButton = (_props: StripePaymentButtonProps) => {
  return null;
};

// ─── Types ──────────────────────────────────────────────────────────────────

type StripePaymentButtonProps = {
  isDisabled: boolean;
  onPress: () => void;
};
